import { render, staticRenderFns } from "./admin-comment-filter.vue?vue&type=template&id=518429d2&scoped=true"
import script from "./admin-comment-filter.vue?vue&type=script&lang=ts"
export * from "./admin-comment-filter.vue?vue&type=script&lang=ts"
import style0 from "./admin-comment-filter.vue?vue&type=style&index=0&id=518429d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518429d2",
  null
  
)

export default component.exports